<template>

    <form-group :validator="v" :label="label" :label-for="id" 
        :description="tip ? tip : 'Format: MM/DD/YYYY.'"
        :messages="messages">
        <template slot-scope="{ attrs, listeners }">
            <b-form-datepicker
                :id="id" v-model="text" 
                v-bind="attrs"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                :state="v.$dirty ? !v.$error : null"
                v-on="listeners"
                :data-test="slug"
                :required="!v.required"
                locale="en">
            </b-form-datepicker>
        </template>
    </form-group>
    
</template>

<script>
import _ from "lodash"

export default {
    components: {
    },
    props: {
        value: [String, Number],
        v: [Object],
        label: [String],
        tip: [String],
        slug: [String],
        required: [Boolean],
        plaintext: Boolean,
        messages: [Object]
    },
    data() {
        return {
            options: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
                 icons: {
                    time: 'far fa-clock',
                    date: 'far fa-calendar',
                    up: 'fas fa-arrow-up',
                    down: 'fas fa-arrow-down',
                    previous: 'arrow-left-circle',
                    next: 'fas fa-chevron-right',
                    today: 'fas fa-calendar-check',
                    clear: 'far fa-trash-alt',
                    close: 'far fa-times-circle'
                }
            }, 
        }
    },
    computed: {
        id() {
            return _.uniqueId('date')
        },
        text: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            }
        }   
    }
}
</script>
<style>
.form-group > label {
    font-weight: 750;
}
</style>